import { type AxiosInstance } from 'axios'

type MeasurementPayload = {
  name: string
  unit: string
  unit_description: string
}

export default (axios: AxiosInstance) => ({
  getMeasurements() {
    return axios.get('/v1/measurements/')
  },
  createMeasurements(measurementsData: MeasurementPayload) {
    return axios.post('/v1/measurements/', measurementsData)
  },
  getMeasurementsById(id: number | string) {
    return axios.get(`/v1/measurements/${id}/`)
  },
  getUnitMeasurements(id: number | string) {
    return axios.get(`/v1/units/measurements/${id}/units/`)
  },
  updateMeasurement(id: number | string, data: MeasurementPayload) {
    return axios.put(`/v1/measurements/${id}/`, data)
  },
  deleteMeasurement(id: number | string) {
    return axios.delete(`/v1/measurements/${id}/`)
  },
  groups() {
    return axios.get<UnitGroup[]>('/v1/measurements/unit-groups/')
  },
})
